export { positionElements, Positioning } from './ng-positioning';
export { PositioningService } from './positioning.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/positioning/index.js
// module id = 29
// module chunks = 3